import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
import Header from "../../components/header";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../shared/type";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

import { HelmetSeo } from "../../components/HelmetSeo";

interface GuidesSectionProps {
  guidesData: dataListsType[];
  nation: string;
}

const GuidesSection = ({ nation, guidesData }: GuidesSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-wider flex justify-between">
        <span>
          Transport Tips for
          <b className="text-[#181818]">{` ${nation}`}</b>
        </span>
        <Link
          className="font-bold text-[#c9b077]"
          to={{
            pathname: "/morepage",
            search: `?category=Guides&nation=${encodeURIComponent(
              nation
            )}&label=${encodeURIComponent(`Transport Tips for ${nation}`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-16 h-[3px] bg-[#c9b077]"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight
        props={guidesData.sort(() => Math.random() - 0.5).slice(0, 2)}
      />
    </div>
  </div>
);

export default function Guides() {
  const [guidesData, setGuidesData] = useState<{
    Japan: dataListsType[];
    Indonesia: dataListsType[];
    China: dataListsType[];
    India: dataListsType[];
    // Singapore: dataListsType[];
  }>({
    Japan: [],
    Indonesia: [],
    China: [],
    India: [],
    // Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Guides");
    setGuidesData({
      Japan: allData.filter((item) => item.nation === "Japan"),
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      // Singapore: allData.filter((item) => item.nation === "Singapore"),
      China: allData.filter((item) => item.nation === "China"),
      India: allData.filter((item) => item.nation === "India"),
    });
  }, []);

  return (
    <>
      <HelmetSeo
        title="Travel Guides - Explore Asia | Transportation & Local Tips"
        description="Discover comprehensive travel guides for Asia, including transportation tips, local insights, and essential information for traveling in China, Japan, Indonesia and more."
        ogType="website"
      />
      {/* <Helmet>
        <title>
          Travel Guides - Explore Asia | Transportation & Local Tips
        </title>
        <meta
          name="description"
          content="Discover comprehensive travel guides for Asia, including transportation tips, local insights, and essential information for traveling in China, Japan, Indonesia and more."
        />
      </Helmet> */}
      <Header />
      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Guides</h1>
          {Object.entries(guidesData).map(([nation, data]) => (
            <GuidesSection key={nation} nation={nation} guidesData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
